import styled from 'styled-components';
import {colorPalette, defaultSize, viewSize} from '../../../config';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ImgWrapper = styled.div`
	margin-bottom: 5rem;
`;

export const CardWrapper = styled.div``;

// export const CardSection = styled.div`
// 	margin-bottom: 3.75rem;
// `;
export const VideoSection = styled.div`
	margin-bottom: 5rem;
`;
export const YoutubeWrapper = styled.div`
	width: 80%;
	max-width: 1000px;
	margin: 2rem auto;

	@media only screen and (max-width: ${viewSize.tablet}) {
		width: 90%;
	}

	@media only screen and (max-width: ${viewSize.mobile}) {
		width: 95%;
	}
`;
export const YoutubeSection = styled.div`
	width: 100%;
	max-width: ${defaultSize.desktopContainer};
	// padding: 0 1rem;
	box-sizing: border-box;

	@media screen and (max-width: ${viewSize.tablet}) {
		max-width: ${defaultSize.tabletContainer};
	}
`;

// export const YoutubeTitle = styled.h2`
// 	font-size: 26px;
// 	color: ${colorPalette.primary};
// 	margin-bottom: 1.5rem;
// 	font-family: 'Gmarket';

// 	@media screen and (max-width: ${viewSize.mobile}) {
// 		font-size: 22px;
// 		margin-bottom: 1rem;
// 	}
// `;

export const YoutubeContainer = styled.div`
	position: relative;
	width: 100%;
	padding-top: 56.25%; /* 16:9 비율 */
	overflow: hidden;
	border-radius: 1rem;

	iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		border: none;
	}
`;
